import React from 'react';
import HeroCarousel from '../components/HeroCarousel/HeroCarousel';
import WhatIBring from '../components/WhatIBring/WhatIBring';
import AboutMe from '../components/AboutMe/AboutMe';
import Mycase from '../components/Mycase/Mycase';

const Home = () => {
  return (
    <>
      {/* Hero Carousel */}
      <HeroCarousel />

      {/* Expertise Section - Updated What I Bring */}
      <WhatIBring />

      {/* About Me Section */}
      <AboutMe />

      {/* My Vision Case Studies Section */}
      <Mycase />
    </>
  );
};

export default Home;
